export enum JournalFileType {
  Fec = 0,
  Pdf = 2,
  Xlsx = 3,
}
